import { useRef } from "react";
import { useDispatch } from "react-redux";
import { getCoursesByBrand } from "../../../../../redux/actions/courses";
import { IFilter } from "../../models/course";

interface PaginationProps {
  filters: IFilter;
}

function useHandlePagination({ filters }: PaginationProps) {
  const dispatch = useDispatch();
  const rowsPerPage = useRef<number>(8);
  const pageNumber = useRef<number>(1);

  const getResourcesFromAPI = () => {
    const pagination = {
      pageNumber: pageNumber.current,
      rowsPerPage: rowsPerPage.current,
    };
    dispatch(getCoursesByBrand({ filters, pagination }));
  };

  const nextPage = () => {
    pageNumber.current++;
    getResourcesFromAPI();
  };

  const resetPage = () => {
    pageNumber.current = 1;
    getResourcesFromAPI();
  };

  const initializePagination = () => {
    getResourcesFromAPI();
  };

  return {
    rowsPerPage: rowsPerPage.current,
    pageNumber: pageNumber.current,
    nextPage,
    resetPage,
    getResourcesFromAPI,
    initializePagination,
  };
}

export default useHandlePagination;
